import { useTheme } from "../context/ThemeContext";
export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme(); 
  return (
    <div>
      <button onClick={toggleTheme} className="btn btn-outline-secondary">
        {theme === "light" ? (
          <i className="bi bi-cloud-sun" style={{ fontSize: "1.5rem" }}></i>
        ) : (
          <i className="bi bi-cloud-moon" style={{ fontSize: "1.5rem" }}></i>
        )}
      </button>
    </div>
  );
}
